import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:158
* @route '/app/creator/setup/appearance'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/setup/appearance',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:158
* @route '/app/creator/setup/appearance'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:158
* @route '/app/creator/setup/appearance'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:158
* @route '/app/creator/setup/appearance'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::store
* @see app/Http/Controllers/Creator/SetupController.php:158
* @route '/app/creator/setup/appearance'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const appearance = {
    store: Object.assign(store, store),
}

export default appearance